(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var layer = document.querySelector('.sk-ambient');
  if(!layer) return;
  var amounts = [149, 249, 389, 499, 549, 799, 899, 1199, 1490, 2490];
  var cart = "<svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='#fff' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'><circle cx='9' cy='20' r='1.6'/><circle cx='18' cy='20' r='1.6'/><path d='M2 3h3l2.6 12.2a1.6 1.6 0 0 0 1.6 1.3h8.5a1.6 1.6 0 0 0 1.6-1.2L21 7H6.1'/></svg>";
  var trend = "<svg width='38' height='14' viewBox='0 0 38 14' fill='none' stroke='#9C8CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M1 12 9 8l6 3 8-7 6 3 8-6'/></svg>";
  function pick(a){ return a[Math.floor(Math.random() * a.length)]; }
  function max(){ return window.innerWidth < 700 ? 4 : 9; }
  function spawn(){
    if(document.hidden || layer.childElementCount >= max()) return;
    var el = document.createElement('span'), r = Math.random(), depth = Math.random();
    if(r < 0.5){
      el.className = 'sk-amb sk-amb--plus';
      el.textContent = '+' + pick(amounts).toLocaleString('sv-SE') + ' kr';
    } else if(r < 0.8){
      el.className = 'sk-amb';
      el.innerHTML = '<i>' + cart + '</i>Ny order';
    } else {
      el.className = 'sk-amb';
      el.innerHTML = '<i>' + cart + '</i>' + trend;
    }
    el.style.left = (2 + Math.random() * 88) + '%';
    el.style.fontSize = (11 + (1 - depth) * 4).toFixed(1) + 'px';
    el.style.setProperty('--d', (16 + depth * 12).toFixed(1) + 's');
    el.style.setProperty('--o', (0.22 + (1 - depth) * 0.38).toFixed(2));
    el.style.setProperty('--b', (depth * 1.8).toFixed(1) + 'px');
    el.style.setProperty('--dx', ((Math.random() - 0.5) * 90).toFixed(0) + 'px');
    el.addEventListener('animationend', function(){ if(el.parentNode) el.parentNode.removeChild(el); });
    layer.appendChild(el);
  }
  for(var i = 0; i < 3; i++) setTimeout(spawn, i * 500);
  setInterval(spawn, 1800);
})();